import {USER_SWITCH_APPLICATION} from '~/frontend/src/constants';
import {StoreState, AppDispatch, Thunk} from '~/frontend/src/store';
import saveCfgItem from '~/frontend/src/actions/user/saveCfgItem';
import reload from '~/frontend/src/actions/user/reloadUser';


export type SwitchApplicationAction = {
    type : typeof USER_SWITCH_APPLICATION;
    name : string
}

/**
 * @memberOf! Actions
 *
 * @return {}
 */
const switchApplication = ( name : string ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<void> => {
    dispatch( {
        type: USER_SWITCH_APPLICATION,
        name
    } );

    const user = getState().session.user;

    if ( user ) {
        user.applicationName = name;

        if ( await dispatch( saveCfgItem() ) ) {
            await dispatch( reload() );
        }
    }
}

export type SwitchApplication = typeof switchApplication;

export default switchApplication;
